import { APP_CATEGORIES, RESET } from '../types';

import { Categories } from '@/api/api';

export const state = () => ({
  categories: null,
});

export const getters = {
  [APP_CATEGORIES]({ categories }) {
    return categories;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [APP_CATEGORIES](stateObj, categories) {
    stateObj.categories = categories;
  },

  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [APP_CATEGORIES]({ commit }) {
    return Categories.getCategories()
      .then(categories => {
        commit(APP_CATEGORIES, [...categories]);
      })
      .catch(({ message = '' }) => Promise.reject(message));
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
